export default __webpack_public_path__ + "static/media/8G.b0f18f92.png";